import React from 'react';

const Donate: React.FC = () => {
    return (
        <div>
        </div>
    );
}; export default Donate; // By John Michael
